module.exports = __webpack_public_path__ + "img/4.da6b050f.png";